import React from 'react';
import './HoverAreaItem.css';

const HoverAreaItem = ({title, children}) => {

  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {    
    setIsHovered(true);
  }

  const handleMouseLeave = () => {
    setIsHovered(false);
  }

  return (
    <div className='hoverAreaItem' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className='itemTitle'  >
        {title}
      </div>
      {isHovered && <div className='itemText'> 
                      {children}
                    </div>}

      {!isHovered && <div className='itemText hidden'> </div> }
    </div>
  );
};

export default HoverAreaItem;